import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { TextStyle } from 'react-native';

export const buttonLabelStyles: TextStyle = {
  fontFamily: OwnableTheme.fonts.gilroy.regular,
  fontWeight: '600',
  fontSize: IS_SMALL_SCREEN ? 10 : 15,
  letterSpacing: IS_SMALL_SCREEN ? 0.3 : 0.45,
};
